// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"954c77f7","279":"09b601af","314":"1ec83016","333":"aa5cdf3d","360":"e703cf69","410":"513e917d","457":"f4d6720b","618":"45461412","628":"fd12304b","799":"0de47b37","945":"a1a076d6"}[chunkId] + ".chunk.js";
};